"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var loadCalendarEvents_1 = require("./actions/loadCalendarEvents");
exports.loadCalendarEvents = loadCalendarEvents_1.default;
var loadWeatherForecast_1 = require("./actions/loadWeatherForecast");
exports.loadWeatherForecast = loadWeatherForecast_1.default;
var UpNext_1 = require("./components/UpNext");
exports.UpNext = UpNext_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/lazyIndex.js
// module id = 2341
// module chunks = 48